module.exports = __webpack_public_path__ + "static/media/spotify-suggester-min.af2be329.png";